






























import store from '@/store'
import ApiClient from '@/js/api.js'
import NormalButton from '@/views/atoms/NormalButton.vue'
import FooterTopButton from '@/views/templates/footer/FooterTopButton.vue'

export default
  name: 'FooterLink'

  components: {
    NormalButton
    FooterTopButton
  }

  data: () ->
    scrollY: 0
    isLoginFlg: false

  computed: {
    is_login: () ->
      @isLoginFlg = await store.getters.isLogin
      return @isLoginFlg
  }

  methods: {
    go_login: () ->
      try
        @$router.push '/login'
      catch e
        console.log e
    go_user_append: () ->
      try
        @$router.push '/user/append'
      catch e
        console.log e
    go_mypage: () ->
      try
        @$router.push '/mypage'
      catch e
        console.log e
    go_logout: (e) ->
      api = new ApiClient()
      data = await api.get('/member/login/logout')
      store.dispatch('setLoginStatus', false)
      @$router.push '/'
    go_top: () ->
      @$emit('go_top')
  }
